import React from 'react';
import { Button, Popup } from 'semantic-ui-react';
import './forms.css';

export const PButton = ({
    name,
    loading,
    className,
    primary,
    secondary,
    onClick,
    buttonText,
    children,
    popup,
    floated,
    disabled = false,
}) => {
    const buttonElement = (
        <Button
            type="button"
            className={`p-button${className ? ` ${className}` : ''}`}
            onClick={onClick}
            floated={floated}
            disabled={disabled}
            primary={primary}
            secondary={secondary}
            loading={loading}>
            {buttonText ? (
                <span className="button-text">{buttonText}</span>
            ) : null}
            {children}
        </Button>
    );

    return (
        <div className="button-container">
            {popup ? (
                <Popup
                    content={popup.content}
                    on={popup?.on || 'hover'}
                    disabled={popup?.disabled === true}
                    position={popup?.position || 'right center'}
                    size="tiny"
                    style={popup?.style}
                    trigger={
                        <div style={{ float: floated }}>{buttonElement}</div>
                    }
                />
            ) : (
                buttonElement
            )}
        </div>
    );
};
